import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { userActiveStep } from 'utils/constants/account/user-status';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { lazy } from 'utils/generic/lazy';
import { getUser } from 'store/selectors/user-data';

const { PaggorUploadKYCVerification } = lazy(
  () =>
    import(
      /* webpackChunkName: "Paggor-Upload-KYC-verification" */ 'newcomponents/Shared/account/PaggorUploadKYCVerification'
    )
);

export const PaggorUploadKYCVerificationCheck = () => {
  const user = useSelector(getUser);

  const checkUploadKYCVerification =
    SpringConfigs.SHOW_KYC_UPLOAD &&
    user.active_step === userActiveStep.USER_ACTIVE_STEP_VALUE_43 &&
    user.active_step_state === userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_5;

  if (!checkUploadKYCVerification) {
    return null;
  }

  return (
    <Suspense>
      <PaggorUploadKYCVerification />
    </Suspense>
  );
};
